import { appConfig } from "../config/app.config";
import { getMockHandler } from "./mock";

let tokenProvider: (() => Promise<string | null>) | null = null;

export function setTokenProvider(provider: () => Promise<string | null>): void {
  tokenProvider = provider;
}

export async function apiFetch(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  if (appConfig.useMockApi) {
    const method = options.method || "GET";
    const handler = getMockHandler(method, path);
    if (handler) {
      const body = options.body
        ? JSON.parse(options.body as string)
        : undefined;
      const data = await handler(body);
      return new Response(JSON.stringify(data), {
        status: 200,
        headers: { "Content-Type": "application/json" },
      });
    }
  }

  const token = tokenProvider ? await tokenProvider() : null;

  const headers = new Headers(options.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  if (!headers.has("Content-Type")) {
    headers.set("Content-Type", "application/json");
  }

  return fetch(`${appConfig.apiBaseUrl}${path}`, {
    ...options,
    headers,
  });
}
